import axios from 'axios';

const table = {
    get(config) {
        const params = {
            PageSize: config.per_page,
            Page: config.page,
            SortBy: config.orderby,
            SortDescending: config.sort === 'asc' ? false : true,
        };
        const search = {};
        Object.keys(config.search).forEach(function(key,index) {
            if(config.search[key]){
                search[key] = config.search[key];
            }
        });
        axios.get(config.api + '/paginate', {
            params: Object.assign(params, search)
        }).then(res => {
            const {
                total,
                data,
                lastPage
            } = res.data.data;
            config.rows = data;
            config.total_data = total;
            config.total_page = lastPage;
        }).catch((error) => console.log(error));
    },
    sort: (config, orderby) => {
        const elm = document.getElementById(orderby);
        elm.classList.remove('fa-sort', "fa-sort-" + config.sort);
        config.orderby = orderby;
        config.sort = config.sort === "asc" ? "desc" : "asc";
        elm.classList.add("fa-sort-" + config.sort);
        table.get(config);
    },
    gotoPage(config, page) {
        config.page = page
        table.get(config);
    },
}

export default table;